import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCatalogExport } from "tm-shared/api";
import { arrayToRecord } from "tm-shared/utils";

import { CatalogKey, catalogStorage } from "@/Services/CatalogStorage";

import { setFilteredParams } from "../offline";

export const getCatalogProductsThunk = createAsyncThunk(
    "catalog/fetchAndSave",
    async (_, { dispatch }) => {
        const {
            result: { products, filteredParams },
        } = await getCatalogExport();

        const productsMap = arrayToRecord(products, "barcode");

        await Promise.all([
            catalogStorage.write(CatalogKey.Products, productsMap),
            catalogStorage.saveMeta(CatalogKey.Products, "1"),
        ]);

        dispatch(setFilteredParams(filteredParams));

        return productsMap;
    },
);
